import { createFileRoute } from '@tanstack/react-router'
import ModerationAudit from '@/features/moderation/audit'

export const Route = createFileRoute('/_authenticated/moderation/audit')({
  component: ModerationAudit,
})
